import { callEndpoint } from './apiUtils';

export const leaveSessionApi = (jwt: string) => callEndpoint<LeaveSessionResponse>('leave-session', jwt, 'POST');
